// libs
import React from 'react';

// UI components
import Logo from '../components/LogoHorizontal.js';
import Icon from '@material-ui/core/Icon';

// helpers
import { logAnalyticsEvent } from '../helpers/analytics';

// vars
import { APPOINTMENT_URL } from '../vars/constants';

// styles
import '../css/home3.css';

let Home3 = () => {
    return (
        <div>
            {/* Header */}
            <div className="header-h3">
                <div className="header-container-h3">
                    <div className="logo-container-h3">
                        <Logo height={40} />
                    </div>
                    <div className="schedule-container-h3">
                        <button
                            className="small schedule-btn-h3"
                            style={{
                                backgroundColor: '#1D61AE',
                                border: 'none',
                                color: '#fff',
                                borderRadius: '45px',
                            }}
                            onClick={async () => {
                                await logAnalyticsEvent({
                                    action: 'click',
                                    category: 'Button',
                                    label: 'h3 - book appointment button',
                                });

                                window.location.href = APPOINTMENT_URL;
                            }}
                        >
                            Book An Appointment Online
                        </button>
                        <div
                            className="phone-number-h3"
                            style={{
                                color: 'black',
                                textDecoration: 'none',
                                fontWeight: 'bold',
                                cursor: 'pointer',
                            }}
                            onClick={async () => {
                                await logAnalyticsEvent({
                                    action: 'click',
                                    category: 'Button',
                                    label: 'h3 - phone number button',
                                });

                                window.location.href = 'tel:4152313183';
                            }}
                        >
                            (415) 231-3183
                        </div>
                    </div>
                </div>
            </div>

            {/* Hero Section */}
            <div
                style={{
                    padding: '75px 20px',
                    background:
                        'url(https://scontent-lax3-2.xx.fbcdn.net/v/t1.6435-9/53236125_2119821454738301_1005790192927244288_n.jpg?_nc_cat=103&ccb=1-7&_nc_sid=0b6b33&_nc_ohc=DYoxfq6PsDcQ7kNvwFKzyew&_nc_oc=AdktVYREhJ1RmCbquCGOTuj2GzeF0CMKg_dzeiF73T7vmjiODTlMG3KDpuQZZnDy_hJWJ2OOsDL2DLZa4adoYcTP&_nc_zt=23&_nc_ht=scontent-lax3-2.xx&_nc_gid=LkaiGBlJxbUprm-2I7nM9Q&oh=00_AfLKdEagzs089Rzh0bUXnHNKFhFVx8iW0JXvy-fT_8Gkpw&oe=685478C6) center/cover no-repeat',
                    color: '#fff',
                    backgroundSize: 'cover',
                    width: '100vw',
                    height: 'fit-content',
                    position: 'relative',
                }}
            >
                <div
                    style={{
                        position: 'absolute',
                        backgroundColor: '#1D61AE',
                        opacity: '0.6',
                        inset: 0,
                    }}
                ></div>

                <div
                    style={{
                        position: 'relative',
                        zIndex: 10,
                    }}
                >
                    <div className="hero-section-text-h3">
                        <h1
                            style={{
                                fontSize: '3rem',
                                marginBottom: '20px',
                                color: 'white',
                            }}
                        >
                            Five Star Vegetable Gardening Services
                        </h1>
                        <p>
                            <b>You can count on us!</b>
                        </p>
                        <p style={{ fontSize: 15 }}>
                            Rest assured, with many years of working in the
                            gardening industry, our approach and interaction
                            with our customers are built on the foundation of
                            integrity and trust.
                        </p>
                        <div>
                            <button
                                className="small"
                                style={{
                                    backgroundColor: '#1D61AE',
                                    border: 'none',
                                    color: '#fff',
                                    fontSize: '1rem',
                                    cursor: 'pointer',
                                    borderRadius: '45px',
                                }}
                                onClick={async () => {
                                    await logAnalyticsEvent({
                                        action: 'click',
                                        category: 'Button',
                                        label: 'h3 - schedule service button',
                                    });

                                    window.location.href = 'tel:4152313183';
                                }}
                            >
                                Schedule Service Now! (415) 231-3183
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            {/* Service Area */}
            <div
                style={{
                    backgroundColor: '#1D61AE',
                    paddingTop: 50,
                    paddingBottom: 50,
                    paddingLeft: 15,
                    paddingRight: 15,
                    textAlign: 'center',
                    color: 'white',
                }}
            >
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        marginBottom: 15,
                    }}
                >
                    <Icon>star</Icon>
                    <Icon>star</Icon>
                    <Icon>star</Icon>
                    <Icon>star</Icon>
                    <Icon>star</Icon>
                </div>
                <em style={{ fontSize: 30, fontWeight: 100 }}>
                    Five Star <b>Vegetable Gardening Service</b> In SF Bay Area
                </em>
                <p style={{ marginTop: 15 }}>
                    No service is too large for Yarden, Call Now!{' '}
                    <b>(415) 231-3183</b>
                </p>
            </div>

            {/* Welcome Section */}
            <div
                style={{ padding: 25, marginTop: 25 }}
                className="welcome-section-h3"
            >
                <div style={{ flex: 1 }}>
                    <h3 style={{ color: '#1D61AE', marginBottom: 15 }}>
                        The Gardeners You Can Count On!
                    </h3>
                    <p style={{ fontSize: 15 }}>
                        Hiring the right professionals for the job is important!
                    </p>
                    <p style={{ fontSize: 15 }}>
                        Welcome to Yarden Gardening, where you will find fully
                        qualified and insured gardeners. We offer a broad range
                        of garden design, installation, and maintenance services
                        in general. Finding a professional that is well
                        qualified, and offers rates that are competitive and
                        relevant to the specific service needed, is one of the
                        most important concerns we encounter with our customers.
                    </p>
                    <p style={{ fontSize: 15 }}>
                        So you can rest assured, with many years of working in
                        the gardening industry, our approach and interaction
                        with our customers are built on the foundation of
                        integrity and trust.
                    </p>
                </div>
                <div style={{ flex: 1 }} className="welcome-img-container-h3">
                    <img
                        alt="gardener"
                        className="welcome-img-h3"
                        style={{
                            boxSizing: 'border-box',
                            height: 'auto',
                            maxWidth: '100%',
                            verticalAlign: 'bottom',
                            borderRadius: '50%',
                        }}
                        src="https://yarden-garden.s3.us-west-1.amazonaws.com/static+assets/gardener-with-harvest.jpg"
                    />
                </div>
            </div>

            {/* Services Section */}
            <div
                style={{
                    backgroundColor: '#EEEEEE',
                }}
            >
                <div
                    style={{
                        textAlign: 'center',
                        marginBottom: 15,
                        padding: 25,
                    }}
                >
                    <h4 style={{ fontWeight: 100, color: '#1D61AE' }}>
                        Your Full Service Gardeners
                    </h4>
                    <h4 style={{ color: '#1D61AE' }}>Featured Services</h4>
                </div>
                <div className="service-section-h3">
                    <div
                        style={{
                            backgroundColor: '#1D61AE',
                            height: 200,
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            flex: 1,
                        }}
                    >
                        <div
                            style={{
                                color: 'white',
                                textAlign: 'center',
                                fontSize: 30,
                            }}
                        >
                            <Icon style={{ fontSize: 50 }}>
                                design_services
                            </Icon>
                            <p>Design</p>
                        </div>
                    </div>
                    <div
                        style={{
                            backgroundColor: '#3399ff',
                            height: 200,
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            flex: 1,
                        }}
                    >
                        <div
                            style={{
                                color: 'white',
                                textAlign: 'center',
                                fontSize: 30,
                            }}
                        >
                            <Icon style={{ fontSize: 50 }}>hardware</Icon>
                            <p>Installation</p>
                        </div>
                    </div>
                    <div
                        style={{
                            backgroundColor: '#66b3ff',
                            height: 200,
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            flex: 1,
                        }}
                    >
                        <div
                            style={{
                                color: 'white',
                                textAlign: 'center',
                                fontSize: 30,
                            }}
                        >
                            <Icon style={{ fontSize: 50 }}>compost</Icon>
                            <p>Maintenance</p>
                        </div>
                    </div>
                </div>
            </div>

            {/* Why Yarden Section */}
            <div>
                <div className="why-yarden-section-h3">
                    <div style={{ padding: '0px 25px', flex: 1 }}>
                        <h2
                            style={{
                                fontWeight: 100,
                                color: '#1D61AE',
                                padding: 25,
                                marginBottom: 15,
                            }}
                        >
                            Why Choose Yarden Gardening
                        </h2>
                        <div style={{ display: 'flex' }}>
                            <div
                                style={{
                                    flex: 1,
                                    display: 'flex',
                                    justifyContent: 'center',
                                }}
                            >
                                <Icon
                                    style={{ fontSize: 150, color: '#1D61AE' }}
                                >
                                    volunteer_activism_icon
                                </Icon>
                            </div>
                            <div style={{ flex: 2 }}>
                                <h4
                                    style={{
                                        color: '#1D61AE',
                                        marginBottom: 15,
                                    }}
                                >
                                    Quality Service
                                </h4>
                                <p>We strive for 100% customer satisfaction.</p>
                            </div>
                        </div>
                        <div style={{ display: 'flex' }}>
                            <div
                                style={{
                                    flex: 1,
                                    display: 'flex',
                                    justifyContent: 'center',
                                }}
                            >
                                <Icon
                                    style={{ fontSize: 150, color: '#1D61AE' }}
                                >
                                    how_to_reg_outlined_icon
                                </Icon>
                            </div>
                            <div style={{ flex: 2 }}>
                                <h4
                                    style={{
                                        color: '#1D61AE',
                                        marginBottom: 15,
                                    }}
                                >
                                    Expert Gardeners
                                </h4>
                                <p>
                                    All our gardeners are experienced and
                                    knowledgable.
                                </p>
                            </div>
                        </div>
                        <div style={{ display: 'flex' }}>
                            <div
                                style={{
                                    flex: 1,
                                    display: 'flex',
                                    justifyContent: 'center',
                                }}
                            >
                                <Icon
                                    style={{ fontSize: 150, color: '#1D61AE' }}
                                >
                                    handyman_outlined_icon
                                </Icon>
                            </div>
                            <div style={{ flex: 2 }}>
                                <h4
                                    style={{
                                        color: '#1D61AE',
                                        marginBottom: 15,
                                    }}
                                >
                                    Exceptional Workmanship
                                </h4>
                                <p>
                                    We use the top-the-line products on all our
                                    projects.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div style={{ flex: 1 }}>
                        <img
                            alt="garden bed"
                            width="100%"
                            height="100%"
                            src="https://scontent-lax3-2.xx.fbcdn.net/v/t1.6435-9/117336638_3200745116645924_937584957376499607_n.jpg?_nc_cat=106&ccb=1-7&_nc_sid=0b6b33&_nc_ohc=irS08p2vM2IQ7kNvwFxXRvf&_nc_oc=Adnhjn2kbdqEk4RYMCKEOmwyq8zSD27vwvzttmqHVY4_ToRa2SHkwN8Xf8Gpvwd7YuNcC-Wc828jwGhokRpxaY2F&_nc_zt=23&_nc_ht=scontent-lax3-2.xx&_nc_gid=0ragIjSd4M9BLNfTUS8-sw&oh=00_AfLLxgzFTctnqQthw82zaCZskB-GldKg0bNMh4_rVeAq-w&oe=685562BE"
                        />
                    </div>
                </div>
            </div>

            {/* Customer Reviews Section */}
            <div
                style={{
                    padding: '75px 20px',
                    background:
                        'url(https://plus.unsplash.com/premium_photo-1661475916373-5aaaeb4a5393?q=80&w=2940&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D) center/cover no-repeat',
                    color: '#fff',
                    backgroundSize: 'cover',
                    width: '100vw',
                    height: 'fit-content',
                    position: 'relative',
                }}
            >
                <div
                    style={{
                        position: 'absolute',
                        backgroundColor: '#d9b38c',
                        opacity: '0.9',
                        inset: 0,
                    }}
                ></div>

                <div
                    style={{
                        position: 'relative',
                        zIndex: 10,
                    }}
                >
                    <div>
                        <h1
                            style={{
                                fontSize: '3rem',
                                marginBottom: '20px',
                                color: '#1D61AE',
                                textAlign: 'center',
                            }}
                        >
                            What Our Customers Say
                        </h1>
                        <p
                            style={{
                                fontWeight: 100,
                                color: '#555555',
                                textAlign: 'center',
                            }}
                        >
                            WE LOVE WHAT WE DO & WE LOVE HELPING YOU!
                        </p>
                    </div>
                    <div className="reviews-container">
                        <div style={{ marginBottom: 25, flex: 1 }}>
                            <div
                                style={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    marginBottom: 15,
                                }}
                            >
                                <img
                                    alt="reviewer 1"
                                    src="https://yarden-garden.s3.us-west-1.amazonaws.com/static+assets/review-avatar-1.png"
                                    width={75}
                                    height={75}
                                    style={{ borderRadius: '50%' }}
                                />
                            </div>
                            <h5
                                style={{
                                    color: '#555555',
                                    marginBottom: 15,
                                    textAlign: 'center',
                                }}
                            >
                                Margarita Casanova
                            </h5>
                            <div
                                style={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    marginBottom: 15,
                                }}
                            >
                                <img
                                    alt="Google logo"
                                    width={125}
                                    src="https://happyplumbing.com/wp-content/plugins/bne-testimonials-pro/assets/images/branding-google.png"
                                />
                            </div>
                            <div
                                style={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    marginBottom: 15,
                                    color: '#e7701b',
                                }}
                            >
                                <Icon>star</Icon>
                                <Icon>star</Icon>
                                <Icon>star</Icon>
                                <Icon>star</Icon>
                                <Icon>star</Icon>
                            </div>
                            <div
                                style={{
                                    backgroundColor: '#1D61AE',
                                    padding: 25,
                                }}
                            >
                                <p style={{ fontWeight: 100 }}>
                                    I just pulled the trigger and signed up for
                                    Yarden. The whole process has been a
                                    pleasure from the get go. Jason has been
                                    incredibly patient with me during the many,
                                    many months of construction delays on my
                                    property. I have seen what Yarden has done
                                    for my friends and I cannot wait to start
                                    growing food together!
                                </p>
                            </div>
                        </div>

                        <div style={{ marginBottom: 25, flex: 1 }}>
                            <div
                                style={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    marginBottom: 15,
                                }}
                            >
                                <img
                                    alt="reviewer 2"
                                    src="https://yarden-garden.s3.us-west-1.amazonaws.com/static+assets/review-avatar-2.png"
                                    width={75}
                                    height={75}
                                    style={{ borderRadius: '50%' }}
                                />
                            </div>
                            <h5
                                style={{
                                    color: '#555555',
                                    marginBottom: 15,
                                    textAlign: 'center',
                                }}
                            >
                                Leonardo Barron
                            </h5>
                            <div
                                style={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    marginBottom: 15,
                                }}
                            >
                                <img
                                    alt="Google logo"
                                    width={125}
                                    src="https://happyplumbing.com/wp-content/plugins/bne-testimonials-pro/assets/images/branding-google.png"
                                />
                            </div>
                            <div
                                style={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    marginBottom: 15,
                                    color: '#e7701b',
                                }}
                            >
                                <Icon>star</Icon>
                                <Icon>star</Icon>
                                <Icon>star</Icon>
                                <Icon>star</Icon>
                                <Icon>star</Icon>
                            </div>
                            <div
                                style={{
                                    backgroundColor: '#1D61AE',
                                    padding: 25,
                                }}
                            >
                                <p style={{ fontWeight: 100 }}>
                                    I had a great experience with Yarden. The
                                    team was friendly and helpful, guiding me
                                    through the process of setting up my
                                    vegetable garden. They gave me practical
                                    tips and checked in to make sure everything
                                    was going smoothly. Now I’m growing my own
                                    veggies, and it’s been such a rewarding
                                    experience. Highly recommend!
                                </p>
                            </div>
                        </div>

                        <div style={{ marginBottom: 25, flex: 1 }}>
                            <div
                                style={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    marginBottom: 15,
                                }}
                            >
                                <img
                                    alt="reviewer 3"
                                    src="https://yarden-garden.s3.us-west-1.amazonaws.com/static+assets/review-avatar-3.png"
                                    width={75}
                                    height={75}
                                    style={{ borderRadius: '50%' }}
                                />
                            </div>
                            <h5
                                style={{
                                    color: '#555555',
                                    marginBottom: 15,
                                    textAlign: 'center',
                                }}
                            >
                                Marina Vainshtein
                            </h5>
                            <div
                                style={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    marginBottom: 15,
                                }}
                            >
                                <img
                                    alt="Google logo"
                                    width={125}
                                    src="https://happyplumbing.com/wp-content/plugins/bne-testimonials-pro/assets/images/branding-google.png"
                                />
                            </div>
                            <div
                                style={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    marginBottom: 15,
                                    color: '#e7701b',
                                }}
                            >
                                <Icon>star</Icon>
                                <Icon>star</Icon>
                                <Icon>star</Icon>
                                <Icon>star</Icon>
                                <Icon>star</Icon>
                            </div>
                            <div
                                style={{
                                    backgroundColor: '#1D61AE',
                                    padding: 25,
                                }}
                            >
                                <p style={{ fontWeight: 100 }}>
                                    Yarden are the best gardening experts. Now
                                    that they take care of my garden I wouldn’t
                                    think about cancelling. They grow more food
                                    for me than what they charge PLUS what I
                                    would spend in the grocery store.
                                    <br />
                                    Yarden is a no-brained for smart people
                                    looking to eat healthier while saving tons
                                    of cash.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Footer */}
            <div
                style={{
                    backgroundColor: '#0b2441',
                    color: 'white',
                    padding: 25,
                }}
            >
                <div className="footer-container-h3">
                    <div style={{ flex: 1, padding: 15 }}>
                        <img
                            alt="Yarden logo"
                            width="80%"
                            src="https://yarden-garden.s3.us-west-1.amazonaws.com/static+assets/yarden_horizontal_lockup_wg_fitted.png"
                        />
                        <p
                            style={{
                                fontSize: 15,
                                fontWeight: 100,
                                marginTop: 15,
                            }}
                        >
                            Rest assured, with many years of working in the
                            gardening industry, our approach and interaction
                            with our customers are built on the foundation of
                            integrity and trust.
                        </p>
                    </div>
                    <div style={{ flex: 1, padding: 15 }}>
                        <h4 style={{ color: 'white', marginBottom: 15 }}>
                            <u>Service Areas</u>
                        </h4>
                        <div style={{ display: 'flex' }}>
                            <div style={{ flex: 1 }}>
                                <p style={{ fontSize: 15 }}>
                                    San Francisco
                                    <br />
                                    San Mateo
                                    <br />
                                    Palo Alto
                                    <br />
                                    Mountain View
                                    <br />
                                    San Jose
                                    <br />
                                    Fremont
                                    <br />
                                    Hayward
                                    <br />
                                    Oakland
                                </p>
                            </div>
                            <div style={{ flex: 1 }}>
                                <p style={{ fontSize: 15 }}>
                                    Richmond
                                    <br />
                                    Orinda
                                    <br />
                                    Lafayette
                                    <br />
                                    Walnut Creek
                                    <br />
                                    Concord
                                    <br />
                                    Antioch
                                    <br />
                                    Moraga
                                    <br />
                                    Pleasant Hill
                                </p>
                            </div>
                        </div>
                    </div>
                    <div style={{ flex: 1, padding: 15 }}>
                        <h4 style={{ color: 'white', marginBottom: 15 }}>
                            <u>Quality Services</u>
                        </h4>
                        <div>
                            <p style={{ fontSize: 15 }}>
                                Garden Design
                                <br />
                                Installation
                                <br />
                                Revie Old Garden
                                <br />
                                Maintenance
                                <br />
                                Harvesting
                                <br />
                                Education
                            </p>
                        </div>
                    </div>
                    <div style={{ flex: 1, padding: 15 }}>
                        <h4 style={{ color: 'white', marginBottom: 15 }}>
                            <u>Contact Us</u>
                        </h4>
                        <p style={{ fontSize: 15 }}>
                            <b>Phone Number</b>
                            <br />
                            (415) 231-3183
                        </p>
                        <p style={{ fontSize: 15 }}>
                            <b>Email</b>
                            <br />
                            info@yardengarden.com
                        </p>
                    </div>
                </div>
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        marginTop: 25,
                        fontSize: 15,
                    }}
                >
                    © {new Date().getFullYear()} Yarden Garden Inc. All Rights
                    Reserved.
                </div>
            </div>
        </div>
    );
};

export default Home3;
